
import { FormControl, Tooltip, Select, MenuItem, Checkbox, ListItemText, Button, TextField } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import useFetch from "../../../../utils/useFetch";
import { getToken, getGlobalClientId, getOrgType } from '../../../../utils/Token';
import BaseURL from "../../../../utils/base-uri.json";



export default function DocumentsReport({ close, name }) {


    const menuListRef = useRef(null);
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 224,
                width: 120,

            },
        },
    };
    const [documentTypes, setDocumentTypes] = React.useState([]);
    const [clientlist, setClientlist] = React.useState([]);

    const [selectedDocs, setSelectedDocs] = useState([]);
    const [clientIds, setClientIds] = React.useState([]);
    const [token, setToken] = useState(getToken())

    documentTypes?.sort((a, b) => a.value.localeCompare(b.value));

    useEffect(() => {
        axios
            .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=true&ClientIds=" +
                getGlobalClientId())
            .then((res) => {
                if (res.data.responseCode === 100) {
                    setClientlist(res?.data?.data);
                    if (getOrgType() == "Client") {
                        ChangeClients(res?.data?.data[0]?.value);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const ChangeClients = (val) => {
        setClientIds(val);
        axios
            .get("Documents/GetDocumentTypesForSelectedClients?ClientsList=" + val)
            .then((res) => {
                if (res?.data) {
                    setDocumentTypes(res?.data?.data)
                }
            })
            .catch((err) => {
                console.log(err);
            });

    };

    const handleDocTypeChange = (event) => {
        setSelectedDocs(event.target.value);
    };

    const handleMenuOpen = () => {
        scrollToTopOfOtions();
    };
    return (
        <>

            <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
            <DialogContent>
                <form action={BaseURL?.baseReportUrl + "GetDocumentsforAllClients.aspx"} method="post" target="_blank">
                    <div style={{ marginLeft: "25px" }}>
                        <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>Client</span>
                        <br />
                        {/* <FormControl>
                            <Select
                                onOpen={handleMenuOpen}
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small' sx={{ width: "340px", overflow: "hidden" }}
                                name="ClientIdList"
                                value={clientIds}
                                onChange={handleClientChange}
                                MenuProps={{
                                    ref: menuListRef,
                                    PaperProps: MenuProps.PaperProps,
                                }}
                                renderValue={(selected) =>
                                    selected
                                        .map((value) => clientlist?.find((doc) => doc?.value === value)?.text)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                inputProps={{ 'aria-label': 'Select Documents' }}
                            >
                                <MenuItem key="Select All">
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            clientIds?.length > 0 && clientIds?.length < clientlist?.length
                                        }
                                        checked={clientIds?.length === clientlist?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setClientIds(clientlist?.map((doc) => doc?.value));
                                                scrollToTopOfOtions();
                                            } else {
                                                setClientIds([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                      
                                </MenuItem>
                                {clientlist?.map((doc) => (
                                    <MenuItem key={doc?.value} value={doc?.value} title={doc?.text} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} >
                                        <Checkbox checked={clientIds?.indexOf(doc?.value) > -1} />
                                        <ListItemText primary={doc?.text} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}

                        <FormControl>

                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                value={clientIds}
                                size='small'
                                sx={{ width: "340px", overflow: "hidden" }}
                                name="ClientIdList"
                                onChange={(e) => ChangeClients(e.target.value)}

                                MenuProps={MenuProps}
                            >
                                {clientlist.map((item, index) => (
                                    <MenuItem key={index} value={item.value} title={item.text} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} >
                                        {item.text}
                                    </MenuItem>
                                ))}
                            </Select>


                        </FormControl>
                        <br />

                        <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>Documents</span>
                        <br />
                        <FormControl>
                            <Select
                                onOpen={handleMenuOpen}
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small' sx={{ width: "340px", overflow: "hidden" }}
                                name="doctypeList"
                                value={selectedDocs}
                                onChange={handleDocTypeChange}
                                MenuProps={{
                                    ref: menuListRef,
                                    PaperProps: MenuProps.PaperProps,
                                }}
                                renderValue={(selected) =>
                                    selected
                                        .map((value) => documentTypes?.find((doc) => doc?.key === value)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                inputProps={{ 'aria-label': 'Select Documents' }}
                            >
                                <MenuItem key="Select All" hidden={clientIds == ""}>
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            selectedDocs?.length > 0 && selectedDocs?.length < documentTypes?.length
                                        }
                                        checked={selectedDocs?.length === documentTypes?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setSelectedDocs(documentTypes?.map((doc) => doc?.key));
                                                scrollToTopOfOtions();
                                            } else {
                                                setSelectedDocs([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                                    {/* <ListItemText primary="Select All" /> */}
                                </MenuItem>
                                {documentTypes?.map((doc) => (
                                    <MenuItem key={doc?.key} value={doc?.key} title={doc?.value} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} >
                                        <Checkbox checked={selectedDocs?.indexOf(doc?.key) > -1} />
                                        <ListItemText primary={doc?.value} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField hidden={true} name="OrgType" value={getOrgType()} />

                    </div>

                    <DialogActions>
                        <div className="login-help__buttonContainer">
                            <Button variant="contained" className="login-help-button-cancel" onClick={close}> Cancel</Button>
                            {selectedDocs == "" ? (
                                <Tooltip title="All the fields are mandatory" followCursor>
                                    <span>
                                        <Button
                                            variant="contained"
                                            className="login-button-request"
                                            onClick={close}
                                            disabled={selectedDocs == ""}
                                        >
                                            Create Report
                                        </Button>
                                    </span>
                                </Tooltip>
                            ) : (
                                <Button
                                    variant="contained"
                                    type="submit"
                                    className="login-button-request"
                                    onClick={close}
                                >
                                    Create Report
                                </Button>
                            )}
                        </div>

                    </DialogActions>
                    <input type="hidden" name="token" value={token} />
                </form>

                <br />

            </DialogContent>

        </>
    )
}






